import { yellow } from "@material-ui/core/colors";
import styled from "styled-components";

export const Image = styled("img")`
width:150px;
height:35px;
position: relative;
top:52px;
left:130px;
@media (max-width: 768px) {
    top: 25px;
    left: 20px;
    margin-bottom: 18px;
} 
`;

export const Image1 = styled("img")`
width:36px;
object-fit:contain;
position: fixed;
top:15px;
left:22px;
`;


export const Image2 = styled("img")`
width:37px;
object-fit:contain;
margin-top:-17px;
`;

